import { Pipe, PipeTransform } from '@angular/core';
import intlTelInput from 'intl-tel-input';
import { default as intlTelInputUtils } from 'intl-tel-input/build/js/utils.js';

@Pipe({
    name: 'telephone',
    standalone: false
})
export class TelephonePipe implements PipeTransform {
  transform(number: string | number): string {
    if (!number) return;

    const allCountriesData = intlTelInput.getCountryData();
    const defaultFormat = intlTelInputUtils.numberFormat.INTERNATIONAL;

    const countryData = allCountriesData.find(countryData => {
      return number.toString().startsWith('+' + countryData.dialCode);
    });

    if (countryData) {
      return intlTelInputUtils.formatNumber(number, countryData.iso2, defaultFormat);
    }
    return number.toString();
  }
}
